import { getChainConfigEntry } from '@/config/chain'
import { SavingsAccount } from '@/features/savings/logic/savings-converters/types'
import { OngoingCampaignWithRestrictedCountry } from '@/features/spark-rewards/data/useOngoingCampaignsQuery'
import { assets } from '@/ui/assets'
import { SparkRewardCampaign } from '@/ui/molecules/spark-reward-pill/SparkRewardPill'

export interface FilterRelatedCampaignsParams {
  ongoingCampaigns: OngoingCampaignWithRestrictedCountry[] | undefined
  savingsAccount: SavingsAccount
  chainId: number
}

export function filterRelatedCampaigns({
  ongoingCampaigns,
  savingsAccount,
  chainId,
}: FilterRelatedCampaignsParams): SparkRewardCampaign[] {
  const { tokenDefinitionRepository } = getChainConfigEntry(chainId)

  return (ongoingCampaigns ?? [])
    .filter((campaign) => campaign.type === 'savings')
    .filter(
      (campaign) =>
        !campaign.isGeoBlocked &&
        campaign.savingsTokenAddresses.includes(savingsAccount.savingsToken.address) &&
        campaign.chainId === chainId,
    )
    .map((campaign) => ({
      campaignId: campaign.id,
      rewardTokenSymbol: campaign.rewardTokenSymbol,
      rewardTokenLogo: tokenDefinitionRepository.findBySymbol(campaign.rewardTokenSymbol)?.logo ?? assets.token.unknown,
      longDescription: campaign.longDescription,
      apy: campaign.apy,
    }))
}
